/* global HTMLElement, Hls */

import EventEmitter from 'events'
import ensureZepto from 'amkit3-modules/utils/ensure-zepto'
import { getLogger } from 'amkit3-modules/utils/log4js'
import VodPlayer from '@huyasdk/web_huya_vod'
// import VodPlayer from './hyvodlib';
import cookie from 'amkit3-modules/utils/cookie'
import { getResRoot } from 'amkit3-modules/utils/getResRoot'
import { debounce } from 'amkit3-modules/utils/debounce'
import { isDev, isTest } from 'amkit3-modules/utils/constant'

import {
  PLAYING,
  PAUSED,
  LOAD_METADATA,
  CAN_PLAY,
  TIME_UPDATE,
  BUFFERING,
  NOT_BUFFERING,
  ENDED,
  ERROR,
  START_PROGRESS,
  LOAD_START,
  BROWSER_PAUSE,
} from './playback-event'
import { TIME } from '../player/huya/core'

const logger = getLogger('v/playbacks/huya-vod')

class HTMLVideoHLSPlayback extends EventEmitter {
  constructor(node, options, ready) {
    super()

    // buffer
    // this.checkInterval = 50.0;
    // this.lastPlayPos = 0;
    // this.currentPlayPos = 0;
    // this.bufferingDetected = false;

    this.state = 'ready'

    this.offset = 0
    this.hasPlayed = false

    this.hasBindedResize = false
    this.afterResizing = debounce(() => this.adjustCanvas())

    this.node = node
    this.video = null
    this.container = null

    ready = ready || function () {}
    let asyncReady = (...args) => setTimeout(() => ready.apply(null, args), 0)

    ensureZepto((error, $) => {
      if (error) {
        asyncReady(error)
      } else {
        this.$ = $
        this.options = this.$.extend(
          {},
          {
            src: '',
          },
          options,
        )
        // this.options.src="http://v-replay.cdn.huya.com/record/huyalive/1292002402-1292002402-5549108062943444992-2584128260-10057-A-0-1/2021-02-22-14:56:27_2021-02-22-19:26:46.m3u8";
        if (!this.options.src) {
          asyncReady(new Error('options.src is required'))
        } else {
          this.isBrowserSupported(error => {
            if (!error) {
              this.init(asyncReady)
            } else {
              asyncReady(error)
            }
          })
        }
      }
    })
  }
  isBrowserSupported(cb) {
    if (typeof MediaSource !== 'function') {
      cb(new Error('MediaSource is not supported'))
    } else if (typeof String.prototype.repeat !== 'function') {
      cb(new Error('String.prototype.repeat is not supported'))
    } else {
      cb()
    }
  }
  init(ready) {
    this.initVideo()
    this.initEvents()
    ready()
  }
  getPid() {
    const [url, search] = this.options.url.split('?')
    const value = `?${search}`.match(new RegExp('[?&]pid=([^&]*)(&?)', 'i'))
    const pid = value ? decodeURIComponent(value[1]) : ''
    return pid
  }
  getSource() {
    if (this.options.source) {
      return this.options.source
    }
    return location.host.indexOf('v.huya') > -1 ? 'play' : 'diy'
  }

  initVideo() {
    console.log('initVideo')
    const node = this.node
    const container = node instanceof HTMLElement ? node : document.body
    container.id = 'video-container'
    this.container = container
    const config = {
      appId: isTest || isDev ? 67 : 66, // process.env.NODE_ENV === 'prod' ? 66 : 67,
      uid: Number(cookie.get('yyuid')) || 0,
      guid: '',
      ua: 'webh5&1.0.0&huyavideo',
      // videoElement: video,
      anchorUid: this.getPid(),
      source: this.getSource(),
    }
    logger.info('sdk config', config)
    this.hyplayer = new VodPlayer(config)
    if (this.options.playerConfig && this.hyplayer.setExtendConfig) {
      this.hyplayer.setExtendConfig(this.options.playerConfig)
    }
    this.adjustCanvas()
    console.log(`sdk版本:${VodPlayer.VERSION}`, `构建时间：${VodPlayer.BUILDTIME}`)
  }
  adjustCanvas() {
    this.hyplayer.containerResize &&
      this.hyplayer.containerResize({
        width: this.container.clientWidth,
        height: this.container.clientHeight,
      })
  }
  afterLoading({ codec, canvas, video }) {
    logger.info(`视频编码标准: ${codec}`)

    if (this.video) {
      if (video !== this.video) {
        this.video.pause()
        this.video.setAttribute('src', '')
      }
      this.video.remove()
    }
    if (video) {
      if (this.options.autoplay) {
        video.setAttribute('autoplay', 'autoplay')
      } else {
        video.setAttribute('preload', 'preload')
      }
    }
    this.container.innerHTML = ''
    if (canvas) {
      canvas.style.width = '100%'
      canvas.style.height = '100%'
      if (!this.hasBindedResize) {
        window.addEventListener('resize', this.afterResizing)
        this.hasBindedResize = true
      }
    } else {
      window.removeEventListener('resize', this.afterResizing)
      this.hasBindedResize = false
    }
    this.container.appendChild(canvas ? canvas : video)

    this.video = video
    this.state = 'loaded'
    this.emit(LOAD_METADATA)
    this.hasPlayed = true
  }
  initEvents() {
    this.hyplayer.on(VodPlayer.Event.VIDEO_LOAD_START, (event, video) => {
      logger.info('loadstart')
      this.emit(LOAD_START)
    })
    this.hyplayer.on(VodPlayer.Event.VIDEO_PLAY, (event, data) => {
      logger.info('loadedmetadata', data)
      console.timeEnd(TIME.PLAYSTART_END)
      this.afterLoading(data)
      this.state = 'playing'
      this.emit(PLAYING)
      this.emit(NOT_BUFFERING)
    })
    // sdk不会再触发
    this.hyplayer.on(VodPlayer.Event.VIDEO_PLAYING, () => {
      logger.info('playing ==')
      this.state = 'playing'
      this.emit(PLAYING)
      // setTimeout(() => {
      this.emit(NOT_BUFFERING)
      // }, 100)
    })

    this.hyplayer.on(VodPlayer.Event.VIDEO_PAUSE, () => {
      logger.info('paused')
      this.state = 'pause'
      this.emit(PAUSED)
      this.emit(NOT_BUFFERING)
    })
    this.hyplayer.on(VodPlayer.Event.VIDEO_TIMEUPDATE, () => {
      // logger.info(this.hyplayer.getCurrentTime())
      // logger.info('timeupdate');
      this.state = 'playing'
      this.emit(TIME_UPDATE)
    })
    this.hyplayer.on(VodPlayer.Event.VIDEO_ENDED, () => {
      logger.info('ended')
      this.state = 'ended'
      this.emit(ENDED)
    })
    this.hyplayer.on(VodPlayer.Event.VIDEO_CANPLAY, () => {
      logger.info('canplay')
      this.emit(CAN_PLAY)
    })
    this.hyplayer.on(VodPlayer.Event.PLAY_CARTON, () => {
      logger.info('carton')
      this.state = 'buffering'
      // this.bufferingDetected = true;
      if (!this.hyplayer.getPaused()) {
        this.emit(BUFFERING)
      }
    })

    this.hyplayer.on(VodPlayer.Event.VIDEO_STOP, () => {
      logger.info('stop')
      this.state = 'buffering'
      // this.bufferingDetected = true;
      this.emit(BUFFERING)
    })
    this.hyplayer.on(VodPlayer.Event.BROWSER_PAUSE, e => {
      console.log('BROWSER_PAUSE', VodPlayer.Event.BROWSER_PAUSE)
      this.hyplayer.pause()
      this.state = 'pause'
      this.emit(NOT_BUFFERING)
      this.emit(PAUSED)
      this.emit(BROWSER_PAUSE)
    })
    let isfirstProgress = false
    this.hyplayer.on(VodPlayer.Event.VIDEO_PROGRESS, () => {
      // logger.info('progress');
      if (isfirstProgress) return
      isfirstProgress = true
      this.emitStartProgress()
    })
    this.hyplayer.on(VodPlayer.Event.VIDEO_ERROR, (eventName, error) => {
      this.state = 'error'
      logger.warn('VIDEO_ERROR', error)
      this.error = error
      this.emit(ERROR)
    })

    if (localStorage.getItem('showPlayerBuffer')) {
      setInterval(() => {
        const buffer = this.hyplayer.getBuffered()
        if (buffer && buffer.length) {
          logger.info(`start: ${buffer.start(0)}, end: ${buffer.end(0)}`)
        }
      }, 200)
    }
  }
  play() {
    if (!this.hasStarted) {
      this.hasStarted = true
      logger.info('playback options', this.options)
      const url = this.options.url
      const format = this.options.format
      const config = {
        url,
        type: format === 'm3u8' ? VodPlayer.HLS : VodPlayer.MP4,
        coderate: this.options.definition,
        curBitrate: this.options.definition === 'yuanhua' ? 4000 : Number(this.options.definition),
        originalBitrate: this.options.definition === 'yuanhua' ? 0 : 1,
        vid: this.options.vid,
        liveType: 3,
        lineType: this.options.lineType,
        seekTime: this.options.seekTime || 0,
        h5Root: getResRoot(),
        duration: this.options.duration,
        mp4Size: this.options.size,
        vStreamInfo: this.options.enableH265 ? this.options.vStreamInfo : null,
        isMemoryGear: localStorage.getItem('v-player-profile-definition') ? true : false, // true-记忆档位， false-默认档位
        pullStreamFrom: window.pullStreamFrom || '0', // 0-默认拉流，1-手动切换码率，2-手动切换线路，3-异常触发重拉流
      }
      if (format === 'm3u8' && this.options.ts1Url && this.options.ts1Offset) {
        const rangeInfo = this.options.ts1Offset.split('@')
        config.tsInfo = {
          tsUrl: this.options.ts1Url,
          totalDuration: Number(this.options.duration),
          byteRangeStartOffset: Number(rangeInfo[1]),
          byteRangeEndOffset: Number(rangeInfo[0]),
          discontinuity: false,
          tsStartTime: 0,
        }
      }
      logger.info('sdk start config', config)
      this.hyplayer.start(config)
      this.emit(LOAD_START)
      return
    }

    return this.hyplayer.play()
  }
  getDuration() {
    return this.hyplayer.getDuration()
  }
  getVideoExtractData() {
    return this.hyplayer.getVideoExtractData()
  }
  getCurrentTime() {
    return this.hyplayer.getCurrentTime() + this.offset || 0
  }
  getMuted() {
    return this.hyplayer.getMuted() || false
  }
  getVolume() {
    return this.hyplayer.getVolume() || 0
  }
  setVolume(value) {
    this.hyplayer.setVolume(value)
  }
  getSrc() {
    return this.options.src || ''
  }
  getBuffered() {
    // var buffered = []
    // if (this.hyplayer) {
    //   for (var i = 0; i < this.hyplayer.buffered.length; i++) {
    //     buffered.push([this.hyplayer.buffered.start(i), this.hyplayer.buffered.end(i)])
    //   }
    // }
    // return buffered
    return this.hyplayer.getBuffered()
  }
  getVideoWidth() {
    return this.hyplayer.getVideoWidth() || 0
  }
  getVideoHeight() {
    return this.hyplayer.getVideoHeight() || 0
  }
  emitStartProgress() {
    if (!this.isProgressed) {
      this.isProgressed = true
      this.emit(START_PROGRESS)
    }
  }
  pause() {
    this.hyplayer.pause()
  }
  seek(value) {
    this.hyplayer.seek(value)
  }
  destroy() {
    logger.info('destroy')
    clearInterval(this.checkBufferingTId)
    window.removeEventListener('resize', this.afterResizing)
    if (this.hyplayer) {
      this.pause()
      this.hyplayer.destroy()
    }
  }
  getError() {
    return this.error
  }
  getReadyState() {
    return this.hyplayer.getReadyState()
  }
  getCurrentSrc() {
    return this.options ? this.options.src : ''
  }
  getPlayerState() {
    return this.state
  }
  setPlaybackRate(playbackRate) {
    this.hyplayer.setPlaybackRate(playbackRate)
  }
  setCodeRate(rate) {
    this.hyplayer.setCodeRate(rate)
  }
}

export default HTMLVideoHLSPlayback
